import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Pagination } from './pagination';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.view.html',
    styleUrls: ['./pagination.view.css']
})
export class PaginationComponent {
    @Input() pagination: Pagination;
    @Output() onPageChange: EventEmitter<number> = new EventEmitter();

    constructor() {

    }

    get firstElement(): number {
      return (this.pagination.page * this.pagination.limit) + 1;
    }

    get lastElement(): number {
      return Math.min(this.pagination.numResults, ((this.pagination.page + 1) * this.pagination.limit));
    }

    get maxPage(): number {
      return Math.floor((this.pagination.numResults - 1) / this.pagination.limit);
    }

    get pageIdxs(): number[] {
      const result: number[] = [];
      let firstPage = 0;

      if (this.pagination.page > 3)  {
        firstPage = this.pagination.page - 2;
      }

      if (this.pagination.page > (this.maxPage - 3) && (this.maxPage - 3) > 0) {
        firstPage = this.maxPage - 4;
      }

      for (let i = firstPage; i < firstPage + 5 && i <= this.maxPage; i++) {
        result.push(i);
      }
      return result;
    }

    setPage(page: number): void {
      this.onPageChange.emit(page);
    }

    addPage(page: string): void {
      this.setPage(+page + 1);
    }

}
